module.exports = {
	"amount_plural": "Amounts",
	"increment_plural": "Increments",
	"infinity": "Infinity"
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/en/widget-fallback.json5
// module id = 1965
// module chunks = 6